export default __webpack_public_path__ + "static/bbq-03-4b3e7d7ac789f050ba9a83041475519f.jpg";